<div class="request-internal-note-container">

    <div class="internal-notes-list" *ngIf="internalNotes.length > 0">
        <div class="note-item" *ngFor="let note of internalNotes">
            <div class="note-avatar">
                <img *ngIf="note.user?.picture" [src]="note.user.picture" alt="">
                <div *ngIf="!note.user?.picture" class="avatar-initials">
                    {{ (note.user?.firstName?.[0] || '') + (note.user?.lastName?.[0] || '') }}
                </div>
            </div>

            <div class="note-content">
                <div class="note-header">
                    <span class="note-author">{{ note.user?.firstName }} {{ note.user?.lastName }}</span>
                    <span class="note-date">
                        {{ getRelativeTime(note.date) }}
                        <span class="note-edited" *ngIf="note.edited">&nbsp;({{ 'request_v2.info.internal_notes_edited' | translate }})</span>
                    </span>
                    <button class="edit-button"
                            type="button"
                            *ngIf="isNoteOwner(note) && editingNoteId !== note._id"
                            (click)="startEdit(note)"
                            [attr.aria-label]="'request_v2.internal_notes.edit' | translate">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>

                <!-- View mode -->
                <div class="note-description"
                     *ngIf="editingNoteId !== note._id"
                     [innerHTML]="note.description | renderMentions:currentLang"
                     (click)="onMentionClick($event)"
                     (keydown.enter)="onMentionClick($event)">
                </div>

                <!-- Edit mode -->
                <div class="note-edit-container" *ngIf="editingNoteId === note._id">
                    <div class="edit-input-wrapper">
                        <div #editInput
                             class="internal-note-input"
                             contenteditable="true"
                             (input)="onEditInput()"
                             (keydown)="onEditKeydown($event)"
                             (blur)="onNoteBlur()"
                             (paste)="onPaste($event)">
                        </div>

                        <div class="mention-dropdown" *ngIf="showMentionDropdown">
                            <div class="mention-loading" *ngIf="mentionLoading">
                                <mat-spinner [diameter]="16"></mat-spinner>
                            </div>
                            <ng-container *ngIf="!mentionLoading">
                                <button class="mention-item"
                                     type="button"
                                     *ngFor="let admin of mentionSearchResults"
                                     (mousedown)="onMentionItemMousedown()"
                                     (click)="selectMention(admin)"
                                     (keydown.enter)="selectMention(admin)">
                                    <div class="mention-avatar">
                                        <img *ngIf="admin.picture" [src]="admin.picture" alt="">
                                        <div *ngIf="!admin.picture" class="mention-initials">{{ admin.initials }}</div>
                                    </div>
                                    <div class="mention-info">
                                        <span class="mention-name">{{ admin.name }}</span>
                                        <span class="mention-email">{{ admin.email }}</span>
                                    </div>
                                </button>
                                <div class="mention-no-results" *ngIf="mentionSearchResults.length === 0">
                                    {{ 'request_v2.info.mention_no_results' | translate }}
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="edit-actions">
                        <button class="icon-btn cancel-btn" type="button" (click)="cancelEdit()" [disabled]="isEditLoading">
                            <mat-icon>close</mat-icon>
                        </button>
                        <button class="icon-btn save-btn" type="button" (click)="saveEdit()" [disabled]="isEditLoading">
                            <mat-icon *ngIf="!isEditLoading">check</mat-icon>
                            <mat-spinner *ngIf="isEditLoading" [diameter]="14"></mat-spinner>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="new-note-section" *ngIf="canEdit">
        <div class="input-pill">
            <div #noteInput
                 class="internal-note-input"
                 contenteditable="true"
                 (input)="onNoteInput()"
                 (keydown)="onNoteKeydown($event)"
                 (blur)="onNoteBlur()"
                 (paste)="onPaste($event)"
                 [attr.data-placeholder]="'request_v2.info.internal_notes_placeholder' | translate">
            </div>

            <div class="mention-dropdown" *ngIf="showMentionDropdown && !editingNoteId">
                <div class="mention-loading" *ngIf="mentionLoading">
                    <mat-spinner [diameter]="16"></mat-spinner>
                </div>
                <ng-container *ngIf="!mentionLoading">
                    <button class="mention-item"
                         type="button"
                         *ngFor="let admin of mentionSearchResults"
                         (mousedown)="onMentionItemMousedown()"
                         (click)="selectMention(admin)"
                         (keydown.enter)="selectMention(admin)">
                        <div class="mention-avatar">
                            <img *ngIf="admin.picture" [src]="admin.picture" alt="">
                            <div *ngIf="!admin.picture" class="mention-initials">{{ admin.initials }}</div>
                        </div>
                        <div class="mention-info">
                            <span class="mention-name">{{ admin.name }}</span>
                            <span class="mention-email">{{ admin.email }}</span>
                        </div>
                    </button>
                    <div class="mention-no-results" *ngIf="mentionSearchResults.length === 0">
                        {{ 'request_v2.info.mention_no_results' | translate }}
                    </div>
                </ng-container>
            </div>

            <button class="send-button" type="button" (click)="sendNote()" [disabled]="!hasNote() || isLoading">
                <mat-icon *ngIf="!isLoading">send</mat-icon>
                <mat-spinner *ngIf="isLoading" [diameter]="16"></mat-spinner>
            </button>
        </div>
    </div>

</div>
